export * from "../../../../../../shared/frontend/units/format";

const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const CLOCK_PART_WIDTH = 2;

/** Verstrichene Laufzeit als m:ss bzw. h:mm:ss, ohne Tageswechsel nach 24 Stunden. */
export function formatElapsedSeconds(seconds: number): string {
  const totalSeconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const remainder = String(totalSeconds % SECONDS_PER_MINUTE).padStart(CLOCK_PART_WIDTH, "0");
  if (minutes < MINUTES_PER_HOUR) return `${minutes}:${remainder}`;
  return `${Math.floor(minutes / MINUTES_PER_HOUR)}:${String(minutes % MINUTES_PER_HOUR).padStart(CLOCK_PART_WIDTH, "0")}:${remainder}`;
}
